import { BasicService } from "./core/basic.service";

export class LoginService extends BasicService {

  static async login(query) {
    const data = await this.http.post('/user/login',query)
    return Promise.resolve(data)
  }

  async resetPasswrod(account, checkCode, password, resetWay) {
    console.log(3535)
    const data = this.http.post('/user/userResetPwd', { account, checkCode, password, resetWay });
    return Promise.resolve(data)
  }

  static async loginOut() {
    const data = await this.http.post('/user/logout')
    return Promise.resolve(data)
  }

  static async smsCodeSend(mobile,model,code_num) {
    const data =  await this.http.post('/other/smsCodeSend',{mobile,model,code_num})
    return Promise.resolve(data)
  }

  static sendEmailCode(email, model, code_num) {
    return this.http.post('/other/emailCodeSend', { email, model, code_num })
  }

  static async register(query) {
    const data = await this.http.post('/user/register',query)
    return Promise.resolve(data)
  }

  static async smsLogin(query) {
    const data = await this.http.post('/user/smsLogin',query)
    return Promise.resolve(data)
  }
// 重置密码的时候验证手机号和邮箱是否存在
  static async checkPhone(query) {
    const data = await this.http.post('/user/accountUniqueCheck',query)
    return Promise.resolve(data)
  }
// 重置密码
  static async resetPassword(query) {
    const data = await this.http.post('/user/resetPw',query)
    return Promise.resolve(data)
  }
// 发送验证码
  static async setCheckNumber(query) {
    const data = await this.http.post('/other/codeSend',query)
    return Promise.resolve(data)
  }
}